export default __webpack_public_path__ + "static/media/distanceSensor.20321d2c.svg";